import { applyMiddleware, createStore } from 'redux'

import createSagaMiddleware from 'redux-saga'

import sagas from './redux/sagas'
import reducer from './redux/ducks'

const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);

const store = createStore(reducer, middleware);
sagaMiddleware.run(sagas);

export default store;
